import chroma from 'chroma-js';

import getRelativeContrastColor from './generate-relative-contrasting-color';

// text color faded halfway into the surface, then adjusted until it meets the requested contrast
const getMutedContrastColor = (textColor: string, surfaceColor: string, options?: Parameters<typeof getRelativeContrastColor>[2]) => {
	if (!chroma.valid(textColor) || !chroma.valid(surfaceColor)) {
		return getRelativeContrastColor(textColor, surfaceColor, options);
	}

	const mutedColor = chroma.mix(textColor, surfaceColor, 0.5, 'rgb').hex();
	return getRelativeContrastColor(mutedColor, surfaceColor, options);
};

export default getMutedContrastColor;
